import React, {Component} from 'react'

import {
  CardContent,
  Typography,
} from 'material-ui'

const style = {
  details:{
    paddingLeft: '16px',
    paddingRight: '16px',
  }
}

export default class UnpublishedJob extends Component{
  render(){
    return (
      <CardContent style={style.details}>
        <Typography style={style.details}>This Job is no longer available. It is now <Typography style={{display:'inline-block'}} component={'span'} color='accent' >{this.props.status}</Typography></Typography>
      </CardContent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnpublishedJob.js